var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md video-area"},[_c('a',{attrs:{"href":"#"},on:{"click":_vm.play}})])}
var staticRenderFns = []

export { render, staticRenderFns }